export default __webpack_public_path__ + "static/media/Camping Sale - 800 x 300 GIF.78634ee0.gif";